import { ContractStage } from "../../../../models/Entities/Contracts/ContractStage";
import { Contract } from "../../../../models/Entities/Contracts/Contract";
import { ContractBranch } from "../../../../models/Entities/Contracts/ContractBranch";
import { ErrorType } from "../../../../models/HttpError";

// stores
import * as ContractStageStore from '../../../../redux/middleware/ContractStageMiddleware';
import * as ContractStore from '../../../../redux/middleware/ContractMiddleware';
import * as ProtocolStore from '../../../../redux/middleware/MedicalProtocolMiddleware';
import * as ContractBranchStore from '../../../../redux/middleware/ContractBranchsMiddleware';

//State
import { AppState } from "../../../../redux/reducers";
import { Protocol } from "../../../../models/Entities/Protocols/Protocol";


interface IProps {
    isOpen: boolean;
    openPanel: () => void;
    dismissPanel: () => void;
    ProtocolId: number;
}
  
interface ConnectedProps {
    
    // getting contract status
    isLoadingProtocol: boolean;
    protocolLoadedSuccessfully: boolean;
    failOnLoadingProtocol: boolean;
    errorLoadingContract: ErrorType | undefined;

    // getting contract stages
    isLoadingStages: boolean;
    stagesLoadedSuccessfully: boolean;
    failOnLoadingStages: boolean;
    errorLoadingStages: ErrorType | undefined;
   
    Protocol: Protocol | undefined;
    Stages: ContractStage[];
    Contract: Contract | undefined;
    ContractBranches: ContractBranch[];
}
  
interface DispatchProps {
    GetMedicalProtocolById: typeof ProtocolStore.actionCreators.GetVisitsByProtocolId;
    GetVisitFullByProtocolId: typeof ProtocolStore.actionCreators.GetVisitFullByProtocolId;
    GetContractById: typeof ContractStore.actionCreators.GetContractById;
    GetAllContractsBranchs: typeof ContractBranchStore.actionCreators.GetAllContractsBranchs;
    GetAllContractsStage: typeof ContractStageStore.actionCreators.GetAllContractsStage;
}
  
export type Props = IProps & ConnectedProps & DispatchProps;
  
export const mapStateToProps = (state: AppState, ownProps: IProps) => {

    const CurrentProtocol = state.MedicalProtocols?.list?.find(p => p.id === ownProps.ProtocolId) || undefined;
    const AuxContractId = CurrentProtocol?.contractAssociation?.contractId || undefined;

    return {
    // contract    
    isLoadingContract: state.Contract?.isLoadingOne || false,
    contractLoadedSuccessfully: state.Contract?.successLoadingOne || undefined,
    failOnLoadingContract: state.Contract?.failOnLoadingOne || false,
    errorLoadingContract: state.Contract?.error || undefined,

    // contract stages
    isLoadingStages: CurrentProtocol?.isGettingContractVisits || false,
    stagesLoadedSuccessfully: CurrentProtocol?.gettingContractVisitsSuccess || undefined,
    failOnLoadingStages: CurrentProtocol?.failOnGettingContractVisits || false,
    errorLoadingStages: state.ContractStage?.error || undefined,

    Protocol: CurrentProtocol,
    Contract: state.Contract?.list?.find((contract: Contract) => contract.id === AuxContractId) || undefined,
    ContractBranches: state.ContractBranch?.list || [],
    Stages: CurrentProtocol?.ContractVisits?.sort(
        (a, b) => a.stageOrder - b.stageOrder
    ) || []
       
    }
};
  
export const mapDispatchToProps = {
    ...ContractStageStore.actionCreators,
    ...ContractStore.actionCreators,
    ...ProtocolStore.actionCreators,
    ...ContractBranchStore.actionCreators
};